import { getApiBaseUrl } from '../utils/apiBaseUrl';

const apiBaseUrl = () => getApiBaseUrl() || 'https://localhost:8082';

const request = async (path, { method = 'GET', body } = {}) => {
  const headers = new Headers();
  if (body !== undefined) {
    headers.set('Content-Type', 'application/json');
  }

  const response = await fetch(`${apiBaseUrl()}${path}`, {
    method,
    credentials: 'include',
    headers,
    body: body === undefined ? undefined : JSON.stringify(body),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok || payload?.success === false) {
    const error = new Error(payload?.message || response.statusText || 'Feedback request failed');
    error.status = response.status;
    error.code = payload?.code;
    error.details = payload?.details;
    throw error;
  }
  return payload;
};

export const getBuyerFeedbackSurvey = (token) => (
  request(`/buyer-feedback/survey?token=${encodeURIComponent(token)}`)
);

export const saveBuyerFeedbackPartial = ({
  token,
  answers,
  questionKey,
  surveyVersion,
  stepIndex,
  notifyImmediately,
  generateFollowup,
}) => (
  request('/buyer-feedback/survey', {
    method: 'PATCH',
    body: { token, answers, questionKey, surveyVersion, stepIndex, notifyImmediately, generateFollowup },
  })
);

export const submitBuyerFeedbackSurvey = ({
  token,
  answers,
  questionKey,
  surveyVersion,
  stepIndex,
  callInterest,
  callPreferredWindows,
}) => (
  request('/buyer-feedback/survey/submit', {
    method: 'POST',
    body: { token, answers, questionKey, surveyVersion, stepIndex, callInterest, callPreferredWindows },
  })
);
